import { useEffect } from "react"

export function useTitle(title: string) {
  title = title + ' - Veracity OE'
  // title = 'VeracityOE'
  useEffect(() => {
    const prevTitle = document.title
    document.title = title
    return () => {
      document.title = prevTitle
    }
  })
}